export const handleCopyPaste = (event: any) => {
    event.preventDefault();
  };
  